export enum BusinessRole {
	Owner = 'owner',
	Administrator = 'administrator',
	User = 'user',
	Creative = 'creative',
	Finance = 'finance',
	Guest = 'guest'
}

export const BusinessRoleMap: Readonly<Record<BusinessRole, number>> = {
	[BusinessRole.Owner]: 0,
	[BusinessRole.Administrator]: 1,
	[BusinessRole.User]: 2,
	[BusinessRole.Creative]: 3,
	[BusinessRole.Finance]: 4,
	[BusinessRole.Guest]: 5
};

export const REPORTING_ADMIN_BUSINESS_ROLES: readonly BusinessRole[] = [BusinessRole.Owner, BusinessRole.Administrator];
